import { Controller } from "@hotwired/stimulus"
import { readFormParams, csrfToken } from "./shared"

// Promo-code check/reset AJAX widget. Dispatches `registration:refresh`
// (bubbling, caught by the pricing controller) whenever pricing needs to
// be recomputed after a promo code is applied or cleared.
export default class extends Controller {
  connect() {
    this.formParams = readFormParams(this.element)
    this._onDelegatedClick = this._onDelegatedClick.bind(this)
    this.element.addEventListener("click", this._onDelegatedClick)
  }

  disconnect() {
    this.element.removeEventListener("click", this._onDelegatedClick)
  }

  _onDelegatedClick(event) {
    const checkBtn = event.target.closest(".check-promo-btn.btn")
    if (checkBtn) {
      event.preventDefault()
      this._checkPromoCode(checkBtn)
      return
    }
    const resetBtn = event.target.closest(".reset-promo-btn.btn")
    if (resetBtn) {
      event.preventDefault()
      this._resetPromoCode(resetBtn)
    }
  }

  async _checkPromoCode(button) {
    const codeField = this.element.querySelector(".promo-code-field")
    const reservationField = this.element.querySelector("#user_registration_promo_code_reservation_id")
    const errorEl = this.element.querySelector(".promo-error")

    let data
    try {
      const response = await fetch(button.dataset.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          "X-CSRF-Token": csrfToken(),
        },
        body: new URLSearchParams({
          promo_code: codeField ? codeField.value : "",
          promo_code_reservation_id: reservationField ? reservationField.value : "",
        }),
      })
      data = await response.json()
    } catch (error) {
      window.Sentry?.captureMessage(`Check promo code: ${error}`, "error")
      if (errorEl) errorEl.innerHTML = this.formParams.locale === "en" ? "Code verification failed" : "Ověření kódu se nezdařilo"
      return
    }

    if (data.errors) {
      if (errorEl) errorEl.innerHTML = data.errors
      return
    }

    if (errorEl) errorEl.innerHTML = ""
    if (codeField) {
      codeField.readOnly = true
      codeField.value = data.code
    }
    this._setValue("#user_registration_promo_group_id", data.promo_group_id)
    this._setValue("#user_registration_promo_code_id", data.promo_code_id)
    this._setValue("#user_registration_promo_code_reservation_id", data.promo_code_reservation_id)
    const nameEl = this.element.querySelector(".promo-name")
    if (nameEl) nameEl.innerHTML = data.name

    button.closest("div")?.classList.add("hidden")
    this.element.querySelector(".reset-promo-btn")?.closest("div")?.classList.remove("hidden")

    this.element.dispatchEvent(new CustomEvent("registration:refresh", { bubbles: true }))
  }

  _resetPromoCode(button) {
    const codeField = this.element.querySelector(".promo-code-field")
    const reservationField = this.element.querySelector("#user_registration_promo_code_reservation_id")

    fetch(button.dataset.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken(),
      },
      body: new URLSearchParams({
        promo_code: codeField ? codeField.value : "",
        promo_code_reservation_id: reservationField ? reservationField.value : "",
      }),
    }).catch(() => {})

    if (codeField) {
      codeField.readOnly = false
      codeField.value = ""
    }
    this._setValue("#user_registration_promo_group_id", "")
    this._setValue("#user_registration_promo_code_id", "")
    this._setValue("#user_registration_promo_code_reservation_id", "")
    const nameEl = this.element.querySelector(".promo-name")
    if (nameEl) nameEl.innerHTML = ""

    this.element.querySelector(".check-promo-btn")?.closest("div")?.classList.remove("hidden")
    button.closest("div")?.classList.add("hidden")

    this.element.dispatchEvent(new CustomEvent("registration:refresh", { bubbles: true }))
  }

  _setValue(selector, value) {
    const el = this.element.querySelector(selector)
    if (el) el.value = value ?? ""
  }
}
